import React from "react";
import { useNavigate } from "react-router-dom";

import StatusUpdateFlow from "../components/dashboard/StatusUpdateFlow";
import { useAuth } from "../context/AuthContext";

const StatusUpdateRoute = () => {
  const navigate = useNavigate();
  const { athleteData } = useAuth();

  return (
    <StatusUpdateFlow
      athleteData={athleteData}
      onBack={() => navigate("/athlete/nutrition")}
      onSave={() => navigate("/athlete/nutrition")}
    />
  );
};

export default StatusUpdateRoute;
